import styled from "styled-components";

export const TopNavContainer = styled.div`
  position: fixed;
  top: 0;
  left: auto;
  width: calc(100vw - 40px);
  padding-inline: 20px;
  height: 60px;
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.secondary};
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1;

  @media only screen and (min-width: 501px) {
    width: 500px;
    margin-inline: auto;
  }
`;

export const TopNavPageName = styled.div`
    margin-inline: auto;
    font-weight: bolder;
    color: ${({ theme }) => theme.colors.secondary};
`;
